module.exports = __webpack_public_path__ + "static/media/Stevo.96325bf6.png";